/** Краткие имена бумаг MOEX для UI (ru). */
const TICKER_NAMES_RU = {
    ALRS: "Алроса",
    VTBR: "ВТБ",
    SIBN: "Газпромнефть",
    UNAC: "ОАК",
    ROSN: "Роснефть",
    RAGR: "РусАгро",
    HYDR: "РусГидро",
    SBER: "Сбер",
    TATN: "Татнефть",
    GAZP: "Газпром",
    LKOH: "Лукойл",
    NVTK: "Новатэк",
    GMKN: "Норникель",
    MGNT: "Магнит",
    YNDX: "Яндекс",
    TCSG: "Т-Технологии",
    PLZL: "Полюс",
    MOEX: "Мосбиржа",
    AFKS: "Система",
    IRAO: "Интер РАО",
    FEES: "ФСК",
    MAGN: "ММК",
    NLMK: "НЛМК",
    CHMF: "Северсталь",
    MTSS: "МТС",
    RTKM: "Ростелеком",
    AFLT: "Аэрофлот",
    SNGS: "Сургутнефтегаз",
    SNGSP: "Сургутнефтегаз-п",
    TRNFP: "Транснефть-п",
};
export const formatTickerLabel = (ticker, lang) => {
    const symbol = ticker.trim().toUpperCase();
    if (lang === "ru") {
        const name = TICKER_NAMES_RU[symbol];
        return name ? `${name} · ${symbol}` : symbol;
    }
    return symbol;
};
